import { Fragment, useEffect, useState } from "react"

export const PortStatus = (props:{port:string}) => {

    const [state, setState] = useState<true | false | null>(null);
    useEffect(() => {
        fetch(`./check-port.php?toScan=${props.port}`).then(async (res) => setState(await res.json()))
    })

    return state === null ? <span style={{color:''}}>WAIT...</span> : state === true ? <span style={{color:'green'}}>OPEN</span> : <span style={{color:'red'}}>CLOSED</span>
}